<template>
    <div class="overseasContainer" :class="{'overseasContainerDark' : isDark}">
        <div class="titleBar">
            <span class="modleName"><em :class="{'icon':true, 'isAndroid':isAndroid}"></em>海外专家</span>
            <span class="details" v-if="overseasData.type_num > 0">（{{overseasData.type_num}}条）</span>
            <van-icon class="btn" name="arrow" color="#ffffff" size="14" @click="goModelList" />
        </div>
        <div class="informationBox" @click="goModelList">
            <div class="informationCard">
                <h2>{{overseasData.title}}</h2>
                <div class="conten" v-html="overseasData.content"></div>
                <div class="btm">
                    <span class="league" :style="{color: color}">{{leagueName}}</span>
                    <span class="team"><em class="w">{{homeName}}</em> <em>{{matchState === '3' ? (homeScore + ':' + guestScore) : 'VS'}}</em> <em class="w">{{guestName}}</em></span>
                    <span class="time">{{createTime}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isAndroid } from "../../utils/base";
export default {
    name: 'informationCorpus',
    props: ['overseasData'],
    components: {
    },
    watch: {
        data: {
            handler () {
                this.renderOverseas();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isAndroid () {
            return isAndroid()
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "24",
            txt: "",
            total: 0,
            matchState: "",
            createTime: "",
            color: '',
            homeName: '',
            guestName: '',
            homeScore: '',
            guestScore: '',
            leagueName: ''
        }
    },
    methods: {
        renderOverseas () {
            if (this.overseasData) {
                if (this.overseasData.type_num * 1 > 0) {
                    this.txt = '（' + this.overseasData.type_num + '条）';
                } else {
                    this.txt = "";
                }
                if (this.overseasData.match_info) {
                    this.homeName = this.overseasData.match_info.home_team_name;
                    this.guestName = this.overseasData.match_info.away_team_name;
                    this.leagueName = this.overseasData.match_info.tournament_name;
                    this.color = this.overseasData.match_info.tournament_color;
                    this.matchState = this.overseasData.match_info.match_status;
                    this.homeScore = this.overseasData.match_info.home_score;
                    this.guestScore = this.overseasData.match_info.away_score;
                    this.createTime = this.overseasData.match_info.match_time.substring(2, 16).replace(/-/g, '.');
                }
            }
        },
        // 跳转模型列表页
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>

<style lang="less" scoped>
.overseasContainer{
    width: 100%;
    height: auto;
    padding-bottom: 5px;
    background: #033194;
    border-radius: 5px;
    .titleBar{
        position: relative;
        width: 100%;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        background-image: url('../../assets/img/datamodel/overseasBackground.png');
        background-size: cover;
        span{
            display: inline-block;
            vertical-align: middle;
            &.modleName{
                position: relative;
                padding-left: 22px;
                font-size: 14px;
                font-weight: bold;
                color: #FFFFFF;
                .icon{
                    position: absolute;
                    top: 3px;
                    left: 0;
                    width: 22px;
                    height: 22px;
                    background-image: url('../../assets/img/datamodel/overseas.png');
                    background-size: cover;
                    &.isAndroid{
                        top: 0.5px;
                    }
                }
            }
            &.details{
                font-size: 13px;
                color: #FFFFFF;
            }
        }
        .btn{
            position: absolute;
            top: 9px;
            right: 2px;
        }
    }
    .informationBox{
        width: 100%;
        padding: 0 5px;
        .informationCard{
            width: 100%;
            height: auto;
            padding: 8px 5px 0px;
            background: #FFFFFF;
            border-radius: 2.5px;
            h2{
                font-size: 13px;
                font-weight: bold;
                color: #333333;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .conten{
                height: 43px;
                line-height: 15px;
                margin-top: 4px;
                font-size: 12px;
                color: #666666;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 5px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                text-align: center;
                .league{
                    float: left;
                    height: 30px;
                    width: 65px;
                    max-width: 65px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                }
                .team{
                    color: #333333;
                    em{
                        display: inline-block;
                        vertical-align: middle;
                        color: #FF5048;
                        &.w{
                            color: #333333;
                            max-width: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
        }
    }
}
.overseasContainerDark {
    .titleBar {
        span {
            &.modleName {
                color: #d3d3d3;
            }
            &.details {
                color: #191919;
            }
        }
    }
    .informationBox {
        .informationCard {
            background: #191919;
            h2 {
                color: #d3d3d3;
            }
            .conten{
                color: #a6a6a6;
            }
            .btm {
                border-color: #2f2f2f;
                .team {
                    color: #d3d3d3;
                    em{
                        &.w {
                            color: #d3d3d3;
                        }
                    }
                }
                .time {
                    color: #a6a6a6;
                }
            }
        }
    }
}
</style>
